import React, { useEffect, useRef, useState } from 'react';
import { Navigation } from '../../components/nav/Navigation';
import { Outlet } from 'react-router-dom';
import AppContext from './AppContext';
import { ApiUrls } from '../../helpers/ApiUrls';
import { getData } from '../../services/ApiService';
import AuthorizeContext from './AuthrizeContext';
import { AuthService } from '../../services/AuthService';


interface LandmarkContainerProps {
    role: string; // or you can use specific role types like 'main', 'header', 'nav', etc.
    children: React.ReactNode;
  }

const LandmarkContainer : React.FC<LandmarkContainerProps> =  ({ role, children }) => {
    return <div role={role}>{children}</div>;
};


interface userInterface{
    email: string;
    isActive: boolean;
    name: string;
    roleID: number;
    roleName: string;
    userId: number;
}

interface permissionsInterface{
    canRead: boolean;
    canView: boolean;
    canWrite: boolean;
    permissionId: number;
    permissionName: string;
    roleId: number;
}
    

const AppLayout = () => {
    const [ appFilters, setAppFilters] = useState('');
    const dataFetchedRef = useRef(false);

    const [user, setUser] = useState<userInterface>(
        {
            email: '',
            isActive: false,
            name: '',
            roleID: 0,
            roleName: '',
            userId: 0 
        }
    );
    const [permissions, setPermissions] = useState<[permissionsInterface]>([
        {
            canRead: false,
            canView: false,
            canWrite: false,
            permissionId: 0,
            permissionName: '',
            roleId: 0
        }
    ]);
    const [isPermisssionLoaded, setIsPermissionLoaded] = useState(false);
    
    useEffect(() => {
        if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
        
        const authService = new AuthService();
        authService.getIDToken().then((token)=>{
            const requests = [
                getData(ApiUrls.countries),
                getData(ApiUrls.customers),
                getData(ApiUrls.airports),
                getData(ApiUrls.errortypes),
                getData(ApiUrls.operationalStatus)
            ];
            Promise.all(requests)
            .then((responses) => {
                const obj = {
                    countries: responses[0].data,
                    customers: responses[1].data,
                    airports: responses[2].data,
                    errortypes: responses[3].data,
                    operationalStatus: responses[4].data
                };
                setAppFilters(JSON.stringify(obj));
                
            })
            .catch((error) => {
                console.log("ERROR>>>>>>>>>>>>>>", error);
                //setApiErrorResponse(error.message+"\n"+error.config.url);
            });

            getData(ApiUrls.userBasic).then((response) => {
                setUser(response.data);
            }).catch((error) => {
                console.log("ERROR:: ", error);
            });

            getData(ApiUrls.userPermissions).then((response) => {
                setPermissions(response.data);
                setIsPermissionLoaded(true);
            }).catch((error) => {
                console.log("ERROR:: ", error);
            });
        }).catch((error)=>{
            console.log("ERROR:: ", error);
        });
        // Use Promise.all to group the requests
        
    },[]);

    return (
        <>
            <AppContext.Provider value={appFilters}>
                <LandmarkContainer role="banner">
                    <Navigation user={user} permissions={permissions}/>
                </LandmarkContainer>
                <LandmarkContainer role="main">
                    <AuthorizeContext.Provider value={{user:user, permissions:permissions, isPermissionLoaded: isPermisssionLoaded}}>
                        <Outlet />
                    </AuthorizeContext.Provider>
                </LandmarkContainer>
            </AppContext.Provider>
        </>
    )
}

export default AppLayout;
